export var DocsBlockCategory;
(function (DocsBlockCategory) {
    /** Shows as a "Text Blocks" */
    DocsBlockCategory["text"] = "Text";
    /** Show as "Layout blocks" */
    DocsBlockCategory["layout"] = "Layout";
    /** Show as "Media blocks" */
    DocsBlockCategory["media"] = "Media";
    /** Show as "Embed blocks" */
    DocsBlockCategory["embed"] = "Embed";
    /** Show as "Figma blocks" */
    DocsBlockCategory["figma"] = "Figma";
    /** Show as "Code blocks" */
    DocsBlockCategory["code"] = "Code";
    /** Show as "Guidelines blocks" */
    DocsBlockCategory["guidelines"] = "Guidelines";
    /** Show as "Token blocks" */
    DocsBlockCategory["token"] = "Tokens";
    /** Show as "Component blocks" */
    DocsBlockCategory["component"] = "Components";
    /** Shows as "Asset blocks" */
    DocsBlockCategory["asset"] = "Assets";
    /** Show as "Data blocks" */
    DocsBlockCategory["data"] = "Data";
    /** Shows as "Other blocks" */
    DocsBlockCategory["other"] = "Other";
})(DocsBlockCategory || (DocsBlockCategory = {}));
